import { ONE_PAGE_STORE_TRACKER_TYPE } from '../../../../shop/constants/tracker';
import { getInjector } from '../../utils/getInjector';

/**
 * @param {object} payload
 * @param {array} payload.error_type - The type of error, available value: 'product_error' | 'payment_error' | 'delivery_error'
 */

export const onTrackCartError = async (payload) => {
  const injector = await getInjector();
  const trackerService = injector.get('trackerService');

  trackerService.track({
    type: ONE_PAGE_STORE_TRACKER_TYPE.CartError,
    data: {
      event_category: 'Cart',
      scope: 'one_page_store',
      error_type: payload.error_type,
    },
  });
};
